export { default as SafariShareIcon } from '~icons/ion/share-outline';
